const enterpriseIds = {
  atci_gendertechprgs:"atci.gendertechprgs",
  uma_rani_battu: "uma.rani.battu",
  arpita_singh:"arpita.m.singh",
  ankur_mishra:"ankur.e.mishra",
  reshmi_haridas:"reshmi.haridas.m",
  jeevadharani_ramanan:"jeevadharani.ramanan",
};

const domain = "accenture.com";


const atcigendertechprgs = `${enterpriseIds.atci_gendertechprgs}@${domain}`
const umaranibattu = `${enterpriseIds.uma_rani_battu}@${domain}`;
const arpitasingh = `${enterpriseIds.arpita_singh}@${domain}`;
const ankurmishra = `${enterpriseIds.ankur_mishra}@${domain}`;
const reshmiharidas = `${enterpriseIds.reshmi_haridas}@${domain}`;
const jeevadharani_ramanan = `${enterpriseIds.jeevadharani_ramanan}@${domain}`;


export default {
  atcigendertechprgs,
  umaranibattu,
  arpitasingh,
  ankurmishra,
  reshmiharidas,
  jeevadharani_ramanan
};
